export default __webpack_public_path__ + "static/media/info-icon.c5387b1b.svg";